import React, { Component } from 'react';
import WidgetBox from './widget-box';

class ErrorBoundary extends Component {
  state = {
    hasError: false
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
  }

  render() {
    if (this.state.hasError) {
      return (
        <WidgetBox title="Widget error" type="danger">
          <p className="bold">An unexpected error occurred while attempting to render widget.</p>
        </WidgetBox>
      );
    }

    return this.props.children;
  }
};

export default ErrorBoundary;


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/components/error-boundary.js